<template>
  <div>
    <div class="row mt-0">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-7">
            <atom-select
              v-model="contractFilter.startMonth"
              title="Start Month"
              placeholder="Select Month"
              label="name"
              :option="contractMonthStartOptions"
              :isClearable="false"
              @input="handleChangeStatMonth"
            ></atom-select>
          </div>
          <div class="col-12 col-sm-6 col-md-5 mt-1 mt-sm-0">
            <atom-select
              v-model="contractFilter.startYear"
              title="Start Year"
              placeholder="Select Year"
              label="name"
              :option="contractStartYearOptions"
              :isClearable="false"
              @input="handleChangeStartYear"
            ></atom-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-5 mt-3 mt-sm-1 mt-md-0">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-7">
            <atom-select
              v-model="contractFilter.endMonth"
              title="End Month"
              placeholder="Select Month"
              label="name"
              :option="contractMonthEndOptions"
              :isClearable="false"
              @input="handleChangeEndMonth"
            ></atom-select>
          </div>
          <div class="col-12 col-sm-6 col-md-5 mt-1 mt-sm-0">
            <atom-select
              v-model="contractFilter.endYear"
              title="End Year"
              placeholder="Select Year"
              label="name"
              :option="contractEndYearOptions"
              :isClearable="false"
              @input="handleChangeEndYear"
            ></atom-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12 col-lg-5 mt-1 mt-lg-0">
        <atom-multi-select
          title="Status"
          placeholder="All Status"
          v-model="contractFilter.statuses"
          label="name"
          :isEnableProper="false"
          :isAppendToBody="false"
          :option="contractStatusOptions"
        ></atom-multi-select>
      </div>
      <div class="col-12 col-lg-5 mt-1 mt-lg-0">
        <atom-multi-select
          title="Business Type"
          placeholder="All Business Type"
          v-model="contractFilter.businessTypes"
          label="name"
          :isEnableProper="false"
          :isAppendToBody="false"
          :option="contractBusinessTypeOptions"
        ></atom-multi-select>
      </div>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import { DateTime } from "luxon"

export default {
  name: "MoleculeReportFilterContract",
  components: { AtomSelect, AtomMultiSelect },
  props: {
    contractBusinessTypeOptions: {
      type: Array,
      required: true,
    },
    contractStatusOptions: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contractStartYearOptions: [],
      contractEndYearOptions: [],
      contractMonthStartOptions: [],
      contractMonthEndOptions: [],
      contractMonthOptions: [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" },
      ],

      thisMonth: DateTime.now().month,
      thisYear: DateTime.now().year,
    }
  },
  computed: {
    contractFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
  mounted() {
    // set contact report
    this.contractFilter.endMonth = this.contractMonthOptions.find(
      (item) => item.id == this.thisMonth
    )

    this.handleChangeStartYear(this.thisYear)
    this.handleChangeEndYear(this.thisYear)

    this.getStartYearOption()
    this.getEndYearOption()
  },

  methods: {
    getStartYearOption() {
      const years = []
      for (let year = this.contractFilter.endYear; year >= 2000; year -= 1) {
        years.push(year)
      }

      this.contractStartYearOptions = years
    },

    getEndYearOption() {
      const years = []
      for (
        let year = this.thisYear;
        year >= this.contractFilter.startYear;
        year -= 1
      ) {
        years.push(year)
      }

      this.contractEndYearOptions = years
    },

    getStartMonthOption(limitMonth) {
      this.contractMonthStartOptions = this.contractMonthOptions.filter(
        (item) => item.id <= limitMonth
      )
    },

    getEndMonthOption(limitMonth) {
      this.contractMonthEndOptions = this.contractMonthOptions.filter(
        (item) => item.id >= limitMonth
      )
    },

    setDefaultStartMonth() {
      const hasStartMonthInList = this.contractMonthStartOptions.find(
        (month) => month.id === this.contractFilter.startMonth.id
      )

      if (!hasStartMonthInList) {
        this.contractFilter.startMonth = this.contractMonthOptions.find(
          (item) => item.id === 1
        )
      }
    },

    setDefaultEndMonth() {
      const month =
        this.contractFilter.endYear === this.thisYear ? this.thisMonth : 12

      const hasEndMonth = this.contractMonthEndOptions.find(
        (month) => month.id == this.contractFilter.endMonth.id
      )

      if (!hasEndMonth) {
        this.contractFilter.endMonth = this.contractMonthOptions.find(
          (item) => item.id === month
        )
      }
    },

    handleChangeStatMonth(event) {
      this.contractMonthEndOptions = this.contractMonthOptions

      if (this.contractFilter.startYear === this.contractFilter.endYear) {
        this.getEndMonthOption(event.id)

        this.setDefaultStartMonth()
        this.setDefaultEndMonth()
      }
    },

    handleChangeEndMonth(event) {
      this.contractMonthStartOptions = this.contractMonthOptions

      if (this.contractFilter.startYear === this.contractFilter.endYear) {
        this.getStartMonthOption(event.id)

        this.setDefaultStartMonth()
        this.setDefaultEndMonth()
      }
    },

    handleChangeStartYear(event) {
      this.getEndYearOption()
      this.contractMonthStartOptions = this.contractMonthOptions
      this.contractMonthEndOptions = this.contractMonthOptions

      if (this.contractFilter.endYear === this.thisYear) {
        this.contractMonthEndOptions = this.contractMonthOptions.filter(
          (item) => item.id <= this.thisMonth
        )
      }

      if (event === this.thisYear) {
        this.getStartMonthOption(this.thisMonth)
        this.setDefaultStartMonth()
      } else if (event === this.contractFilter.endYear) {
        this.getStartMonthOption(this.contractFilter.endMonth.id)
        this.setDefaultStartMonth()

        this.getEndMonthOption(this.contractFilter.startMonth.id)
      }
    },

    handleChangeEndYear(event) {
      this.getStartYearOption()
      this.contractMonthStartOptions = this.contractMonthOptions
      this.contractMonthEndOptions = this.contractMonthOptions

      if (this.contractFilter.startYear === this.thisYear) {
        this.getStartMonthOption(this.thisMonth)
      }

      if (event === this.thisYear) {
        this.contractMonthEndOptions = this.contractMonthOptions.filter(
          (item) => item.id <= this.thisMonth
        )
        this.setDefaultEndMonth()
      } else if (event === this.contractFilter.startYear) {
        this.getEndMonthOption(this.contractFilter.startMonth.id)
        this.setDefaultEndMonth()

        this.getStartMonthOption(this.contractFilter.endMonth.id)
      }
    },
  },
}
</script>

<style></style>
